// Memorial entry for Itay Chen
import itayChenPortrait from '../../../images/itay-chen.jpg';

export const itayChenMemorial = {
  id: 42,
  name: 'Staff Sgt. Itay Chen',
  images: {
    portrait: itayChenPortrait
  },
  info: `
"There is no option to give up. It's our son." - His mother Hagit

# Staff Sergeant Itay Chen

![Itay Chen](${itayChenPortrait})
*Staff Sergeant Itay Chen, 19, Israeli-American tank gunner*

## Triple Citizen, One Mission

Itay Chen held American, Israeli, and German citizenship. His father Ruby was born in Brooklyn to Holocaust survivors. The family moved to Israel, but regularly visited relatives in New York.

He grew up in Netanya, played basketball for Elitzur Netanya, loved the Boston Celtics. He was a rock climber, breakdancer, and Boy Scout counselor. He enlisted as a tank gunner in August 2022.

He was 19 years old.

## October 7, 2023

Itay had switched weekends to be home for his younger brother's bar mitzvah the following week. Instead, he was at Nahal Oz base when Hamas attacked.

His tank crew fought for hours, killing dozens of terrorists. Eventually their tank was struck. Itay was killed. His body was taken to Gaza.

## The Family's Fight

Ruby and Hagit Chen became tireless advocates. Ruby met President Biden, spoke at the UN, testified before Congress. They flew to Washington every few weeks.

The family refused to hold a funeral until Itay's remains returned. "We don't finish this until he comes home."

## The Last American

On November 4, 2025 - 760 days later - Itay came home. He was the last American hostage held in Gaza.

His mother: "My heart is broken. There is no joy in laying your child to rest, but there is relief and peace for the soul."

His crewmate Matan Angrest, released after two years in captivity, came to salute him.

*The life of the party. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/staff-sgt-itay-chen-19-american-israeli-tank-gunner-loved-basketball/)
`
};
